<template>

	<header>
		<HeaderContactInfo />
		<HeaderSiteNavigation />
	</header>

</template>

<script>

	import HeaderContactInfo from './HeaderContactInfo';
	import HeaderSiteNavigation from './HeaderSiteNavigation';
	
	export default {
		components: {
			HeaderContactInfo,
			HeaderSiteNavigation,
		}
	};

</script>